// extracted by mini-css-extract-plugin
export default {"root":"ArticleItem_root__hDiGU","header":"ArticleItem_header__d2iEh","headerContent":"ArticleItem_headerContent__2Sb-R","body":"ArticleItem_body__rHATO"};